import { useEffect, useState } from 'react'
import { apiClient } from '@indipia/shared'

/**
 * 인증이 필요한 사진 경로를 apiClient(Authorization 자동 첨부)로 받아 objectURL 목록으로 만든다.
 * enabled 가 true 인 동안만 받고, 실패한 항목은 null. 해제는 언마운트·입력 변경 때 자동.
 * (ThumbImg 와 같이 게이트웨이 전체경로의 선행 /api 를 뗀다 — apiClient.baseURL 이 이미 /api)
 */
export function useBlobUrls(urls: string[], enabled: boolean): (string | null)[] | null {
  const [blobs, setBlobs] = useState<(string | null)[] | null>(null)
  const key = urls.join('|')
  useEffect(() => {
    if (!enabled || urls.length === 0) return
    const controller = new AbortController()
    const created: string[] = []
    Promise.all(urls.map(async u => {
      try {
        const res = await apiClient.get<Blob>(u.replace(/^\/api(?=\/)/, ''), { responseType: 'blob', signal: controller.signal })
        const o = URL.createObjectURL(res.data)
        created.push(o)
        return o
      } catch { return null }
    })).then(list => { if (!controller.signal.aborted) setBlobs(list) })
    return () => {
      controller.abort()
      created.forEach(o => URL.revokeObjectURL(o))
      setBlobs(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, key])
  return blobs
}
